import React, { useEffect, useState } from "react";

import { useHistory } from "react-router-dom";

import RegisterDeveloperWithoutCompany from "../../../../../presentation/pages/register-account/register-developer-without-company";

import { makeRemoteStack } from "../../../usecases/stack/remote-stack-factory";

import { api } from "../../../../../infra/http/remote";

import {
  handleCepChange,
  handleNoStackChange,
  makeDeveloper,
  showSuccessMessage,
  showErrorMessage,
  saveDataToLocalStorage,
  getErrorMessage,
} from "../../../../../presentation/helpers";

import { getUserRegisterInfo } from "./utils";

const isMobile = window.innerWidth < 768;

const MakeRegisterDeveloperWithoutCompany: React.FC = () => {
  const { userEmail, registerData } = getUserRegisterInfo();

  const history = useHistory();

  const [errorMessage] = useState<string | null>("");

  const [stacks, setStacks] = useState<any[]>([]);

  useEffect(() => {
    const fetchStacks = async (): Promise<void> => {
      const response = await makeRemoteStack().loadAll();
      setStacks(response);
    };
    fetchStacks();
  }, []);

  const createRequestBody = (data: any): any => ({
    ...makeDeveloper(data),
    stacks: data.stacks.map((stack: any) => ({ id: stack })),
  });

  const submitDeveloperRegistration = async (
    requestBody: any,
  ): Promise<void> => {
    await api.post("/public/register/developer/step-one", requestBody);
  };

  const redirect = (path: string): void => {
    history.push(path);
  };

  const handleSubmit = async (data: any): Promise<void> => {
    const requestBody = createRequestBody(data);

    try {
      await submitDeveloperRegistration(requestBody);
      showSuccessMessage("Salvo com sucesso!");
      saveDataToLocalStorage("registerData", requestBody);
      redirect("/cadastro-basico/2");
    } catch (error: any) {
      showErrorMessage(getErrorMessage(error));
    }
  };

  const goBack = (): void => {
    history.goBack();
  };

  const dataForm = [
    {
      items: [
        {
          name: "title",
          component: "Title",
          title: "Dados pessoais: ",
          number: 1,
        },
        {
          component: "InputGroup",
          style: {
            display: isMobile ? "flex" : "grid",
            gridTemplateColumns: "2fr 1fr",
            flexDirection: isMobile ? "column" : "row",
            gap: isMobile ? 0 : "16px",
          },
          inputs: [
            {
              name: "name",
              component: "Input",
              value: registerData?.name || "",
              title: "Nome",
              label: "Nome",
              placeholder: "Ex. João da Silva",
              required: true,
              validations: "inputRequired",
            },
            {
              component: "InputMask",
              mask: "CPF",
              name: "cpf",
              label: "CPF",
              title: "CPF",
              placeholder: "000.000.000-00",
              value: registerData?.cpf || "",
              required: true,
              validations: "cpfValidation",
            },
          ],
        },
        {
          component: "InputGroup",
          style: {
            display: isMobile ? "flex" : "grid",
            gridTemplateColumns: "1fr 1fr 1fr",
            flexDirection: isMobile ? "column" : "row",
            gap: isMobile ? 0 : "16px",
          },
          inputs: [
            {
              name: "email",
              component: "Input",
              value: userEmail || "",
              title: "E-mail",
              label: "E-mail",
              disabled: Boolean(registerData?.email),
              required: true,
              validations: "emailRequired",
            },
            {
              component: "InputMask",
              mask: "MOBILE_NUMBER",
              name: "phone",
              placeholder: "(00) 00000-0000",
              label: "Telefone",
              title: "Telefone",
              value:
                (registerData?.phone?.ddd &&
                  registerData?.phone?.number &&
                  `${registerData?.phone?.ddd}${registerData?.phone?.number}`) ||
                "",
              required: true,
              validations: "phoneNumberRequired",
            },
          ],
        },
        {
          component: "InputGroup",
          style: {
            display: isMobile ? "flex" : "grid",
            gridTemplateColumns: "2fr 1fr",
            flexDirection: isMobile ? "column" : "row",
            gap: isMobile ? 0 : "16px",
          },
          hasDivider: true,
          inputs: [
            {
              name: "stacks",
              title: "Stacks",
              component: "Multiselect",
              styleContainer: { margin: "0px", marginTop: isMobile && "10px" },
              initialSelectedOptions:
                registerData?.stacks?.map((stack: any) => stack.id) || [],
              options: stacks
                .filter((stack) => stack.description !== "Não desejo informar")
                .map((stack) => ({
                  label: stack.description,
                  value: stack.id,
                })),
            },
            {
              component: "InputGroup",
              style: {
                display: "flex",
                flexDirection: "column",
                marginTop: isMobile && "20px",
                width: "100%",
              },
              inputs: [
                {
                  name: "otherStack",
                  component: "MultipleTextInput",
                  styleContainer: {
                    margin: "0px",
                  },
                  value: registerData?.otherStack || "",
                  title: "Outra stack",
                  label: "Outra stack",
                },
                {
                  name: "noStack",
                  component: "InputCheck",
                  checked:
                    registerData?.stacks?.some(
                      (stack: any) =>
                        stack.description === "Não desejo informar",
                    ) || false,
                  title: "",
                  label: "",

                  onChange: (value: any, el: any) =>
                    handleNoStackChange(value, el, stacks),
                  options: [
                    {
                      value: "true",
                      label: "Não desejo informar",
                      name: "Não desejo informar",
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          name: "title",
          component: "Title",
          title: "Endereço Residencial: ",
          number: 2,
        },
        {
          component: "InputGroup",
          style: {
            display: isMobile ? "flex" : "grid",
            gridTemplateColumns: "1fr 2fr",
            flexDirection: isMobile ? "column" : "row",
            gap: isMobile ? 0 : "16px",
          },
          inputs: [
            {
              name: "developerCep",
              component: "InputMask",
              mask: "CEP",
              label: "CEP",
              title: "CEP",
              placeholder: "00000-000",
              value: registerData?.address?.zipCode || "",
              required: true,
              validations: "inputRequired",
              onChange: (data: any, el: any) =>
                handleCepChange(data, el, "developer"),
            },
            {
              component: "Input",
              name: "developerStreet",
              label: "Rua",
              title: "Rua",
              placeholder: "Ex. Rua das Flores",
              value: registerData?.address?.place || "",
              required: true,
              validations: "inputRequired",
            },
          ],
        },
        {
          component: "InputGroup",
          style: {
            display: isMobile ? "flex" : "grid",
            gridTemplateColumns: "1fr 1fr 1fr",
            flexDirection: isMobile ? "column" : "row",
            gap: isMobile ? 0 : "16px",
          },
          inputs: [
            {
              name: "developerNumber",
              component: "Input",
              label: "Número",
              title: "Número",
              placeholder: "Ex. 123",
              value: registerData?.address?.number || "",
              required: true,
              validations: "inputRequired",
            },
            {
              name: "developerNeighborhood",
              component: "Input",
              label: "Bairro",
              title: "Bairro",
              placeholder: "Ex. Jardim das Flores",
              value: registerData?.address?.district || "",
              required: true,
              validations: "inputRequired",
            },
            {
              name: "developerComplement",
              component: "Input",
              label: "Complemento",
              title: "Complemento",
              placeholder: "Ex. Casa 2",
              value: registerData?.address?.complement || "",
              required: false,
            },
          ],
        },
        {
          component: "InputGroup",
          style: {
            display: isMobile ? "flex" : "grid",
            gridTemplateColumns: "1fr 1fr 1fr",
            flexDirection: isMobile ? "column" : "row",
            gap: isMobile ? 0 : "16px",
          },
          hasDivider: true,
          inputs: [
            {
              name: "developerCity",
              component: "Input",
              label: "Cidade",
              title: "Cidade",
              placeholder: "Ex. São Paulo",
              value: registerData?.address?.city || "",
              required: true,
              validations: "inputRequired",
            },
            {
              name: "developerState",
              component: "Input",
              label: "Estado",
              title: "Estado",
              placeholder: "Ex. SP",
              value: registerData?.address?.state || "",
              required: true,
              validations: "inputRequired",
            },
          ],
        },
        {
          component: "InputGroup",
          style: {
            display: "flex",
            gap: "16px",
            width: "100%",
            margin: "auto",
            marginTop: "16px",
          },
          inputs: [
            {
              name: "backButton",
              component: "Button",
              type: "button",
              title: "Voltar",
              onClick: goBack,
              color: false,
            },
            {
              name: "button",
              component: "Button",
              title: "Enviar",
              submittingText: "Carregando...",
              color: true,
            },
          ],
        },
      ],
    },
  ];

  const props = {
    dataForm,
    onSubmit: handleSubmit,
    errorMessage,
  };

  return <RegisterDeveloperWithoutCompany {...props} />;
};

export default MakeRegisterDeveloperWithoutCompany;
